import { render, staticRenderFns } from "./detail-auction.vue?vue&type=template&id=70b4becd&scoped=true"
import script from "./detail-auction.vue?vue&type=script&lang=js"
export * from "./detail-auction.vue?vue&type=script&lang=js"
import style0 from "./detail-auction.vue?vue&type=style&index=0&id=70b4becd&prod&lang=css&scoped=true"
import style1 from "./detail-auction.vue?vue&type=style&index=1&id=70b4becd&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70b4becd",
  null
  
)

export default component.exports